import { config } from "@caixa/config";
import type { CardapioCaixaNotification } from "@/lib/cardapioOperationalNotifications";

async function handleJson<T>(res: Response): Promise<T> {
  const text = await res.text();
  const trimmed = text.trim();
  if (!trimmed) {
    if (res.ok) return {} as T;
    throw new Error("Erro na requisição");
  }
  let data: unknown;
  try {
    data = JSON.parse(trimmed);
  } catch {
    throw new Error("Resposta inválida do servidor");
  }
  if (!res.ok || (data && typeof data === "object" && "ok" in data && (data as { ok?: boolean }).ok === false)) {
    const obj = data && typeof data === "object" ? (data as Record<string, unknown>) : null;
    const msg =
      obj && typeof obj.error === "string"
        ? obj.error
        : obj && typeof obj.message === "string"
          ? obj.message
          : "Erro na requisição";
    throw new Error(msg);
  }
  return data as T;
}

export async function listarCardapioCaixaNotificacoes(): Promise<CardapioCaixaNotification[]> {
  const res = await fetch(`${config.BASE_URL}/caixa/cardapio-notificacoes/list.php`, {
    credentials: "include",
    method: "GET",
    headers: { Accept: "application/json" },
  });
  const data = await handleJson<{ notificacoes?: CardapioCaixaNotification[] }>(res);
  return data.notificacoes ?? [];
}

export async function encerrarCardapioCaixaNotificacao(id: number): Promise<void> {
  const res = await fetch(`${config.BASE_URL}/caixa/cardapio-notificacoes/dismiss.php`, {
    credentials: "include",
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id }),
  });
  await handleJson(res);
}
